// Utility to generate a cryptographically secure random string

const ALPHANUMERIC_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const NUMERIC_CHARS = '0123456789';
const ALPHABETIC_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const URL_SAFE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
const HEX_CHARS = '0123456789abcdef';

const cryptoRandomString = ({ length, type = 'alphanumeric', characters }) => {
    if (!length || length <= 0) {
        throw new Error('Length must be a positive number');
    }

    let charset = characters;
    if (!charset) {
        switch (type) {
            case 'alphanumeric':
                charset = ALPHANUMERIC_CHARS;
                break;
            case 'numeric':
                charset = NUMERIC_CHARS;
                break;
            case 'alphabetic':
                charset = ALPHABETIC_CHARS;
                break;
            case 'url-safe':
                charset = URL_SAFE_CHARS;
                break;
            case 'hex':
                charset = HEX_CHARS;
                break;
            default:
                charset = ALPHANUMERIC_CHARS;
        }
    }

    const charSetSize = charset.length;
    const randomBuffer = new Uint8Array(length);

    if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
        window.crypto.getRandomValues(randomBuffer);
    } else if (typeof global !== 'undefined' && global.crypto && global.crypto.getRandomValues) {
        global.crypto.getRandomValues(randomBuffer);
    } else {
        throw new Error('crypto.getRandomValues is not available');
    }

    let result = '';
    for (let i = 0; i < length; i++) {
        result += charset[randomBuffer[i] % charSetSize];
    }

    return result;
};

export default cryptoRandomString;

export const uuidv4 = () => crypto.randomUUID();
